import React, { useEffect, useState, Suspense } from "react";

import { useParams } from "react-router-dom";

import { useObjectStore } from "../zustand/objects";
import { getSpecificUserProjectGuestAccessAPI } from "../api";
import StoryboardTextField from "../components/StoryboardTextField"

import { Box, Card, Button, Group, Text, Title, Container, Tooltip } from '@mantine/core';


export default function EmbedStoryboardPage() {
  const { updateArtboardAndPreviewCamera, getAIModels, objectsAreLoaded, artboards, getSpecificUserProjectGuest, loadObjects, unloadObjects, screenshots } = useObjectStore();

  const { projectKey } = useParams();

  const [guest, setGuest] = useState(false)

  useEffect(() => {
    Promise.resolve(unloadObjects())
        .then(() => getSpecificUserProjectGuestAccessAPI(projectKey))
        .then((response) => {
            if (response === true) {
                return getSpecificUserProjectGuest(projectKey)
                    .then(() => setGuest(true))
                    .then(() => getAIModels())
                    .then(() => loadObjects())
                    .then(() => updateArtboardAndPreviewCamera(1));
            } else {
                setGuest(false);
                return Promise.resolve(); // Ensure a valid chain end
            }
        });
}, [getAIModels, getSpecificUserProjectGuest, loadObjects, projectKey, unloadObjects, updateArtboardAndPreviewCamera]);


  const GridBackground = () => {
    return (
      <div style={{ position: "fixed", left: 0, top: 0, bottom: 0, zIndex: -1, width: "100%", height: "120%", backgroundImage: 'url("/image/background-grid.png")', backgroundAttachment: "fixed" }}></div>

    )
  } 



  

  return (<>
    <Suspense fallback={<h1>Loading...</h1>}>
      <GridBackground />


      <div style={{ paddingTop: 64, paddingLeft: 0 }}>
        <Container style={{ marginLeft: 56, paddingLeft: 0 }}>
         

          <div style={{ display: "grid", gridTemplateColumns: "7fr 5fr", marginBottom: 16 }}>
            <div>
              <Title order={1} fw={700} mb="xs">
                {guest ? "View prototype storyboard" : "This project is private"} 
              </Title>
            </div>
            
            <div>
              <Group pt={4} justify="flex-end" />
            </div>
          </div>
        </Container>
      </div> 
 
      <Container style={{ paddingBottom: 0, paddingTop: 16, marginLeft: 56, paddingLeft: 0 }} >
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 16 }}>
        
          {artboards && objectsAreLoaded && Object.keys(artboards).map((mapped, i) => (
            <Suspense key={i} fallback={<h1>Loading...</h1>}>
              <div>
              <Card radius={16} padding={0} style={{margin:10}}
                                        shadow="0px 1px 3px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 0px rgba(0, 0, 0, 0.10)">
                  <div>
                    {
                      screenshots[mapped] ? <div
                      style={{
                        width: 300, height: 200,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundImage: `url(${screenshots[mapped]})`,
                      }}
                      size="small" /> :
                      <div
                        style={{
                          width: 260, height: 100,
                          borderRadius: 0, backgroundColor: '#C1C2C5'
                          // width: 130, height: 85, borderRadius: 0, backgroundColor: '#C1C2C5'
                        }}
                        size="small" />
                    }
                  </div>
                <Box sx={{ flexGrow: 1, padding: 16, paddingBottom: 0 }}>
                  <Text fw={600} mb={4}>
                    Scene: {mapped}
                  </Text>
                  <Tooltip label="This is preview mode. Scene info is written in edit mode." position="bottom-start">
                      <span>
                        <StoryboardTextField fieldType="name" isEditable={false} artboard={mapped} />
                      </span></Tooltip>
                    <Tooltip label="This is preview mode. Scene info is written in edit mode." position="bottom-start">
                      <span><StoryboardTextField fieldType="description" isEditable={false} artboard={mapped} />
                      </span></Tooltip>
                    <StoryboardTextField fieldType="comments" isEditable={true} artboard={mapped} />
                </Box>
                <Group style={{margin:10}}>
                  <Button
                    onClick={() => unloadObjects()}
                    style={{
                      width: '45%', inline: true, backgroundColor: 'black', borderRadius: 32
                    }}
                    component='a'
                    href={`/share/${projectKey}?artboard=${mapped}`}>
                    View</Button>
                </Group>
              </Card>
              </div>
              </Suspense>
          ))} 
        </div>
      </Container>
    </Suspense>
  </>
  );
}
